import React from 'react';

export default function TickIcon(props) {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='currentColor'>
        <path d='M23.292 10.294c.39-.391 1.024-.392 1.414-.002.361.36.39.928.085 1.32l-.083.094-10.65 10.67c-.55.548-1.419.58-2.007.098l-.113-.103-4.647-4.665c-.39-.392-.388-1.025.003-1.415.362-.36.929-.386 1.32-.08l.095.083L13 20.604l10.292-10.31z' />
      </g>
    </svg>
  );
}
